<script setup lang="ts">
import { computed } from 'vue'

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger, BlockContainer } from '@toni/brand-ui'

import { usePageStore } from '../../stores/page'
import { usePageBlockWidth } from '../../composables/use-page-block-width.ts'
import { useContentBlock } from '../../content-blocks/composables/use-content-block'
import { useClient } from '../../utils/client-only'
import { toValidHTML } from '../../utils/html-utils.ts'

const props = defineProps<{
  id: string
}>()

const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, 'faq')

const { isClient } = useClient()
const pageStore = usePageStore()
const isHome = computed(() => pageStore.isHome as boolean)
const brand = computed(() => pageStore.brand as string)

const size = computed(() => usePageBlockWidth(pageStore.pageData?.pageMeta, isHome.value, brand.value).value)
</script>

<template>
  <BlockContainer :size="size"
                  class="my-6 md:my-8">
    <Accordion v-if="isClient">
      <AccordionItem v-for="(item, index) in contentBlock.data.faq.items"
                     :key="`faq-item-${index}`"
                     :value="index.toString()">
        <!-- item.heading is either '_none' or a heading level h2, h3 -->
        <AccordionTrigger :as="item.heading === '_none' ? 'span' : item.heading">
          {{ item.question }}
        </AccordionTrigger>
        <AccordionContent class="prose prose-a:text-secondary-500 hover:prose-a:text-primary-350 prose-a:decoration-from-font prose-a:underline-offset-2 prose-p:m-0 prose-li:m-0 prose-li:leading-7 prose-li:ps-0 sm:prose-li:leading-8 prose-li:marker:text-foreground [&_u]:decoration-from-font [&_u]:underline-offset-2 [&_li_p]:m-0">
          <div v-if="item.answer?.html"
               v-html="toValidHTML(item.answer.html)" />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  </BlockContainer>
</template>
